/**
 * Current User Reducer
 * Handles single user state for viewing/editing
 */

import { USERS_ACTION_TYPES } from '../../actions/usersActions';

const initialState = {
  user: null,
  loading: false,
  error: null
};

const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case USERS_ACTION_TYPES.SET_CURRENT_USER:
      return {
        ...state,
        user: action.payload,
        error: null
      };

    case USERS_ACTION_TYPES.CLEAR_CURRENT_USER:
      return {
        ...state,
        user: null,
        error: null
      };

    case USERS_ACTION_TYPES.DELETE_USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case USERS_ACTION_TYPES.DELETE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        user: state.user && state.user.id === action.payload.userId ? null : state.user
      };

    case USERS_ACTION_TYPES.DELETE_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default currentUserReducer;